/* eslint-disable no-console */
/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
/* eslint-disable no-use-before-define */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-multi-assign */
/* eslint-disable no-nested-ternary */
/*
 * FileSaver.js
 * A saveAs() FileSaver implementation.
 *
 * By Eli Grey, http://eligrey.com
 *
 * License : https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md (MIT)
 * source  : http://purl.eligrey.com/github/FileSaver.js
 */

// The one and only way of getting global scope in all environments
// https://stackoverflow.com/q/3277182/1008999
let _global;
if (typeof window === "object" && window.window === window) {
  _global = window;
} else if (typeof self === "object" && self.self === self) {
  _global = self;
} else if (typeof global === "object" && global.global === global) {
  _global = global;
} else {
  _global = this;
}

function bom(blob, opts) {
  if (typeof opts === "undefined") opts = { autoBom: false };
  else if (typeof opts !== "object") {
    console.warn("Deprecated: Expected third argument to be a object");
    opts = { autoBom: !opts };
  }

  // prepend BOM for UTF-8 XML and text/* types (including HTML)
  // note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
  if (
    opts.autoBom &&
    /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(
      blob.type
    )
  ) {
    return new Blob([String.fromCharCode(0xfeff), blob], { type: blob.type });
  }
  return blob;
}

function download(url, name, opts) {
  const xhr = new XMLHttpRequest();
  xhr.open("GET", url);
  xhr.responseType = "blob";
  xhr.onload = () => {
    saveAs(xhr.response, name, opts);
  };
  xhr.onerror = () => {
    console.error("could not download file");
  };
  xhr.send();
}

function corsEnabled(url) {
  const xhr = new XMLHttpRequest();
  // use sync to avoid popup blocker
  xhr.open("HEAD", url, false);
  try {
    xhr.send();
  } catch (e) {
    console.log(e);
  }
  return xhr.status >= 200 && xhr.status <= 299;
}

// `a.click()` doesn't work for all browsers (#465)
function click(node) {
  try {
    node.dispatchEvent(new MouseEvent("click"));
  } catch (e) {
    // Fallback to simple click if dispatchEvent fails or is not supported
    node.click();
  }
}

function handleIOSDownload(reader, popupRef, blob) {
  reader.onloadend = function () {
    let url = reader.result;
    url = isChromeIOS
      ? url
      : url.replace(/^data:[^;]*;/, "data:attachment/file;");
    if (popupRef) popupRef.location.href = url;
    else location = url;
    popupRef = null; // reverse-tabnabbing #460
  };
  reader.readAsDataURL(blob);
}

function handleDefaultDownload(url, popupRef) {
  if (popupRef) popupRef.location = url;
  else location.href = url;
  popupRef = null; // reverse-tabnabbing #460
  setTimeout(() => {
    (_global.URL || _global.webkitURL).revokeObjectURL(url);
  }, 4e4); // 40s
}

const isMacOSWebView =
  _global.navigator &&
  /Macintosh/.test(navigator.userAgent) &&
  /AppleWebKit/.test(navigator.userAgent) &&
  !/Safari/.test(navigator.userAgent);

const isChromeIOS = /CriOS\/\d+/.test(navigator.userAgent);

const shouldUseFileReader = (blob) => {
  // Detect WebView inside a native macOS app by ruling out all browsers
  // We just need to check for 'Safari' because all other browsers (besides Firefox) include that too
  // https://www.whatismybrowser.com/guides/the-latest-user-agent/macos
  const force = blob.type === "application/octet-stream";

  const isSafari = /constructor/i.test(_global.HTMLElement) || _global.safari;

  return (
    (isChromeIOS || (force && isSafari) || isMacOSWebView) &&
    typeof FileReader !== "undefined"
  );
};

let saveAs;

if (_global.saveAs) {
  saveAs = _global.saveAs;
} else if (typeof window !== "object" || window !== _global) {
  // probably in some web worker
  saveAs = function () {
    /* noop */
  };
} else if ("download" in HTMLAnchorElement.prototype && !isMacOSWebView) {
  // Use download attribute first if possible (#193 Lumia mobile) unless this is a macOS WebView
  saveAs = function (blob, name, opts) {
    const URL = _global.URL || _global.webkitURL;
    // Namespace is used to prevent conflict w/ Chrome Poper Blocker extension (Issue #561)
    const a = document.createElementNS("http://www.w3.org/1999/xhtml", "a");
    name = name || blob.name || "download";

    a.download = name;
    a.rel = "noopener"; // tabnabbing


    if (typeof blob === "string") {
      // Support regular links
      a.href = blob;
      if (a.origin !== location.origin) {
        if (corsEnabled(a.href)) {
          download(blob, name, opts);
        } else {
          click(a);
        }
      } else {
        click(a);
      }
    } else {
      // Support blobs
      a.href = URL.createObjectURL(blob);
      setTimeout(() => {
        URL.revokeObjectURL(a.href);
      }, 4e4); // 40s
      setTimeout(() => {
        click(a);
      }, 0);
    }
  };
} else if ("msSaveOrOpenBlob" in navigator) {
  // Use msSaveOrOpenBlob as a second approach
  saveAs = function (blob, name, opts) {
    name = name || blob.name || "download";

    if (typeof blob === "string") {
      if (corsEnabled(blob)) {
        download(blob, name, opts);
      } else {
        const a = document.createElement("a");
        a.href = blob;
        a.target = "_blank";
        setTimeout(() => {
          click(a);
        });
      }
    } else {
      navigator.msSaveOrOpenBlob(bom(blob, opts), name);
    }
  };
} else {
  // Fallback to using FileReader and a popup
  saveAs = (blob, name, opts, popup) => {
    popup = popup || open("", "_blank");
    if (popup) {
      popup.document.title = popup.document.body.innerText = "downloading...";
    }

    if (typeof blob === "string") {
      return download(blob, name, opts);
    }

    if (shouldUseFileReader(blob)) {
      const reader = new FileReader();
      handleIOSDownload(reader, popup, blob);
    } else {
      const URL = _global.URL || _global.webkitURL;
      const url = URL.createObjectURL(blob);
      handleDefaultDownload(url, popup);
    }
  };
}

_global.saveAs = saveAs.saveAs = saveAs;

if (typeof module !== "undefined") {
  module.exports = saveAs;
}
